<div *ngIf="commande.pack" class="d-flex flex-column">
  <h5 class="mb-2">Mon panier</h5>
  <div class="d-flex align-items-end">
    <div class="panier-credit-choisis">
      <h2 class="text-primary mt-0">{{ commande.pack.creditTotal }}</h2>
      <strong>crédits</strong>
    </div>

    <div class="d-flex flex-column align-self-center mx-2">
      <div>
        <h6 class="text-black">
          Pack {{ commande.pack.creditTotal }} crédits
          <span
            *ngIf="commande.pack.creditFree && commande.pack.creditFree > 0"
          >
            dont {{ commande.pack.creditFree }} crédits gratuits
          </span>
          à
          {{ commande.pack.priceNet | currency: "EUR" : "symbol" : "1.2-2" }} HT
        </h6>
        <h6 *ngIf="commande.isRenouvellementAuto" class="fw-light text-black">
          Avec renouvellement automatique
        </h6>
      </div>

      <h6 class="fw-light text-black">
        soit
        {{ commande.pack.priceGross | currency: "EUR" : "symbol" : "1.2-2" }}
        TTC (Tarif TVA France métropolitaine)
      </h6>
    </div>
  </div>
</div>
